module.exports = "/images/vendor/flag-icon-css/flags/1x1/cl.svg?6d63ff70245fe5abcbf9ccc50cecf8c2";